// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Fish,
    FishOff,
    FishSymbol,
    FishingHook,
    FishingRod,
    Flag,
    FlagOff,
    FlagTriangleLeft,
    FlagTriangleRight,
    Flame,
    FlameKindling,
    Flashlight,
    FlashlightOff,
    FlaskConical,
    FlaskConicalOff,
    FlaskRound,
    FlipHorizontal2,
    FlipVertical2,
    Flower,
    Flower2,
    Focus,
    FoldHorizontal,
    FoldVertical,
    Folder,
    FolderArchive,
    FolderBookmark,
    FolderCheck,
    FolderClock,
    FolderClosed,
    FolderCode,
    FolderCog,
    FolderDot,
    FolderDown,
    FolderGit,
    FolderGit2,
    FolderHeart,
    FolderInput,
    FolderKanban,
    FolderKey,
    FolderLock,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "fish" through "folder-lock", inclusive. */
const shard: Record<string, LucideIcon> = {
    fish: Fish,
    "fish-off": FishOff,
    "fish-symbol": FishSymbol,
    "fishing-hook": FishingHook,
    "fishing-rod": FishingRod,
    flag: Flag,
    "flag-off": FlagOff,
    "flag-triangle-left": FlagTriangleLeft,
    "flag-triangle-right": FlagTriangleRight,
    flame: Flame,
    "flame-kindling": FlameKindling,
    flashlight: Flashlight,
    "flashlight-off": FlashlightOff,
    "flask-conical": FlaskConical,
    "flask-conical-off": FlaskConicalOff,
    "flask-round": FlaskRound,
    "flip-horizontal-2": FlipHorizontal2,
    "flip-vertical-2": FlipVertical2,
    flower: Flower,
    "flower-2": Flower2,
    focus: Focus,
    "fold-horizontal": FoldHorizontal,
    "fold-vertical": FoldVertical,
    folder: Folder,
    "folder-archive": FolderArchive,
    "folder-bookmark": FolderBookmark,
    "folder-check": FolderCheck,
    "folder-clock": FolderClock,
    "folder-closed": FolderClosed,
    "folder-code": FolderCode,
    "folder-cog": FolderCog,
    "folder-dot": FolderDot,
    "folder-down": FolderDown,
    "folder-git": FolderGit,
    "folder-git-2": FolderGit2,
    "folder-heart": FolderHeart,
    "folder-input": FolderInput,
    "folder-kanban": FolderKanban,
    "folder-key": FolderKey,
    "folder-lock": FolderLock,
};

export default shard;
